import React from 'react';
import { Icon } from '@iconify/react';
import AnimateHeight from 'react-animate-height';
import TrialTagFields from './TrialTagFields';
import TrialTagChips from './TrialTagChips';
import { SESSION_SCOPE, summarizeTags } from '../../util/trialTagFields';
import '../../../dist/assets/stylesheets/css/recordPatient.css';

/**
 * Session-scoped tags: entered once and applied to every trial recorded in this
 * session, so the per-trial panels only carry what actually varies between runs.
 */
function SessionDetailsCard(props) {
    const { values, onChange, open, onToggle, suggestions, disabled } = props;
    const chips = summarizeTags(values, SESSION_SCOPE);

    return (
        <div
            id="record-session-details"
            className={`session-details-container${open ? ' open' : ''}${disabled ? ' disabled' : ''}`}
        >
            <div
                className="step-card"
                role="button"
                tabIndex={disabled ? -1 : 0}
                aria-expanded={!!open}
                aria-disabled={disabled ? 'true' : undefined}
                aria-controls="record-session-details-dropdown"
                onClick={disabled ? undefined : onToggle}
                onKeyDown={(e) => {
                    if (disabled) return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        onToggle();
                    }
                }}
            >
                <div className="step-card-title-container">
                    {chips.length ? (
                        <Icon className="check" icon="ei:check" />
                    ) : (
                        <Icon icon="la:circle-solid" color="gray" />
                    )}
                    <h5>Session Details</h5>
                    <TrialTagChips items={chips} emptyLabel="Applies to every trial in this session" />
                </div>
                <Icon icon="iconamoon:arrow-up-2-light" className={open ? 'open' : undefined} />
            </div>
            <AnimateHeight
                id="record-session-details-dropdown"
                className="record-dropdown-animate-height"
                duration={420}
                height={open ? 'auto' : 0}
                easing="cubic-bezier(0.33, 1, 0.68, 1)"
                animateOpacity
            >
                <div className="session-details-body">
                    <TrialTagFields
                        scope={SESSION_SCOPE}
                        values={values}
                        onChange={onChange}
                        idPrefix="session-tag"
                        suggestions={suggestions}
                        disabled={disabled}
                    />
                </div>
            </AnimateHeight>
        </div>
    );
}

export default SessionDetailsCard;
